import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section id="about" className="bg-cream py-20 md:py-28 overflow-hidden" data-id="element-9">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-11">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-12">
            <h2 className="font-heading text-forest text-4xl md:text-5xl font-bold mb-4" data-id="element-13">
              Welcome to Camp ALKEBULAN
            </h2>
            <div className="w-20 h-1 bg-gold mb-8 rounded-full" data-id="element-14" />

            <div className="space-y-6 text-brown/80 text-lg leading-relaxed" data-id="element-15">
              <p data-id="element-16">
                Camp ALKEBULAN is more than a summer camp — it's a movement. For
                two transformative weeks, young people ages 7–17 come together
                at Beulah Land Farms to reconnect with their roots, discover
                their purpose, and build lifelong bonds.
              </p>
              <p data-id="element-17">
                Through African-centered education, outdoor adventures, creative
                arts, and community service, campers develop confidence,
                cultural pride, and leadership skills that last a lifetime.
              </p>
              <p data-id="element-18">
                Our name, ALKEBULAN — meaning "Mother of Mankind" — reflects our
                belief that every child carries the seeds of greatness. We're
                here to help them grow.
              </p>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: 'easeOut',
          delay: 0.2
        }} className="relative" data-id="element-19">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl rotate-2 hover:rotate-0 transition-transform duration-500 ease-out" data-id="element-20">
              <img src="https://cdn.magicpatterns.com/uploads/froqtLaTrU4sfsCTZo65n1/camp-group.jpg" alt="Campers gathered together" className="w-full h-auto object-cover aspect-[4/3]" data-id="element-21" />
              <div className="absolute inset-0 ring-1 ring-inset ring-black/10 rounded-2xl" data-id="element-22" />
            </div>

            {/* Decorative element */}
            <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-gold/20 rounded-full blur-2xl -z-10" data-id="element-23" />
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-forest/10 rounded-full blur-2xl -z-10" data-id="element-24" />
          </motion.div>
        </div>
      </div>
    </section>;
}